
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import {
  MailboxRepositoryInterface,
} from '@/services/Mailbox/interfaces';
import { ServerInterface, ServerRepositoryInterface } from '@/services/Server/Interfaces';
import WebsiteRepositoryInterface, { Website } from '@/services/Website/interfaces';
import { WPXFormValue } from '@/components/templates/WPXForm';
import CreateMailboxForm from '@/services/Mailbox/forms/CreateMailboxForm';
import PageHeader from '@/components/layout/PageHeader.vue';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'mailboxRepository',
    'serverRepository',
    'websiteRepository',
  ],
  components: {
    PageHeader,
  },
})
export default class CreateMailbox extends Vue {
  public loading: boolean = true;

  public form: WPXFormValue<CreateMailboxForm> = new WPXFormValue<CreateMailboxForm>(CreateMailboxForm);


  public mailboxRepository!: MailboxRepositoryInterface;
  public serverRepository!: ServerRepositoryInterface;
  public websiteRepository!: WebsiteRepositoryInterface;

  public servers: ServerInterface[] = [];
  public websites: Website[] = [];

  public _websiteSearch: string = '';
  public websiteSearchLoading: boolean = false;


  public async created(): Promise<void> {
    await this.initialize();
    this.loading = false;
  }

  public async initialize(): Promise<void> {
    try {
      await this.getServers();
    } catch (err) {
      this.$errorDialog.show(err.response?.data?.message || err.message);
    }
  }

  public async getServers(): Promise<void> {
    this.servers = await this.serverRepository.getAllServers();
  }

  public get websiteSearch(): string {
    return this._websiteSearch;
  }

  public set websiteSearch(val: string) {
    if (val && val.length < 3) {
      return;
    }

    this._websiteSearch = `server=${this.form.data.server}&domain=${val}`;
    this.websiteSearchLoading = true;
    this.websiteRepository.getByServerAndDomain(this.form.data.server, val).then((websites) => {
      this.websites = websites;
      this.websiteSearchLoading = false;
    }).catch((err) => {
      this.$errorDialog.show(err.message);
    });
  }

  public async createMailbox(): Promise<void> {
    const website = this.websites.find((w) => w.id === this.form.data.websiteId);
    if (!website) {
      this.$errorDialog.show('Website not found!');
    }

    try {
      await this.mailboxRepository.createMailbox({
        server: this.form.data.server,
        websiteId: this.form.data.websiteId,
        systemUserId: Number(website?.details?.unixUserId),
      });

      this.$successDialog.show('Mailbox Creation Started');
      await this.$router.push({ name: 'mailbox_list' });
    } catch (err) {
      this.$errorDialog.show(err.response?.data?.message || err.message);
    }
  }
}
